import React from 'react';
export function Hero() {
  return <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-13">
      <h1 className="font-sans font-bold text-4xl md:text-5xl leading-tight text-[#0F4226] mb-6" data-id="element-14">
        For 2,000 Years, Every Civilization on Earth Kept Fleas and Ticks Off
        Their Animals Without a Drop of Chemicals. Then a $4 Billion Industry
        Convinced Us to Forget Everything They Knew.
      </h1>
      <p className="font-sans text-xl md:text-2xl text-[#666666] leading-relaxed" data-id="element-15">
        The forgotten plant science that protected animals for millennia — and
        the wearable pendant that finally makes it work for the modern pet
        parent who is done choosing between effective and safe.
      </p>
    </div>;
}